"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./DualFluidHeaderFixedContentLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var layoutClasses = (0, _cssClassesHelper.getBEMClasses)('dual-fluid-header-fixed-content-layout');
var DualFluidHeaderFixedContentLayout = function DualFluidHeaderFixedContentLayout(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('accent-bar')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('header-secondary')
  }, props.headerSecondary), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('fixed-container')
  }, props.children), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('footer')
  }, props.footer));
};
var _default = exports["default"] = DualFluidHeaderFixedContentLayout;